import { createFileRoute } from '@tanstack/react-router';

import { TextItemView } from '#/features/community-hub/components/block-viewers/text-item-view';

/**
 * Text item viewer. Path: /programs/{program}/{module}/{lesson}/text/{itemSlug}
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/text/$itemSlug')({
  component: TextContentRoute,
});

function TextContentRoute() {
  const { itemSlug } = Route.useParams();
  // Keyed so opening another item remounts the view instead of keeping the last item's state.
  return <TextItemView key={itemSlug} itemSlug={itemSlug} />;
}
